export const SLIDER_CATEGORY_LOAD_REQUEST = 'SLIDER_CATEGORY_LOAD_REQUEST';
export const SLIDER_HOVER_LOAD_REQUEST = 'SLIDER_HOVER_LOAD_REQUEST';
export const SLIDER_HOVER_LOAD_SUCCESS = 'SLIDER_HOVER_LOAD_SUCCESS';
export const SLIDER_CATEGORY_LOAD_SUCCESS = 'SLIDER_CATEGORY_LOAD_SUCCESS';
export const SLIDER_CATEGORY_LOAD_ERROR = 'SLIDER_CATEGORY_LOAD_ERROR';
export const IRIS_SLIDER_CATEGORY_LOAD_REQUEST = 'IRIS_SLIDER_CATEGORY_LOAD_REQUEST';
export const IRIS_SLIDER_CATEGORY_LOAD_SUCCESS = 'IRIS_SLIDER_CATEGORY_LOAD_SUCCESS';
export const IRIS_SLIDER_CATEGORY_LOAD_ERROR = 'IRIS_SLIDER_CATEGORY_LOAD_ERROR';
export const DISPLAY_HAMBURGER_SLIDER = 'DISPLAY_HAMBURGER_SLIDER';
